import { render, staticRenderFns } from "./BatchAuditTable.vue?vue&type=template&id=520c3bc4&"
import script from "./BatchAuditTable.vue?vue&type=script&lang=ts&"
export * from "./BatchAuditTable.vue?vue&type=script&lang=ts&"
import style0 from "./BatchAuditTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports